import api from "./api/api";

const IaService = {
  gerarResumo: async (payload: any) => {
    try {
      const res = await api.post(`/ia/resumoDesk`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  gerarBriefing: async (payload: any) => {
    try {
      const res = await api.post(`/ia/suggestBriefing`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getVersion: (version: string) => {
    return api.get(`/versao/${version}`);
  },
};

export default IaService;
